<template>
    <div>
        <v-btn color="primary" elevation="0" class="pa-5" dark :loading="loading" :width="width"
            @click="handleFileImport">
            <v-icon class="mr-2">{{ icono }}</v-icon>
            {{ titulo }}
        </v-btn>
        <input ref="uploader" class="d-none" type="file" accept="image/jpg, image/jpeg" @change="onFileChanged">
    </div>
</template>

<script>

import { mapActions, mapGetters } from 'vuex';

export default {
    name: 'InputButton',
    data() {
        return {
            isSelecting: false,
            selectedFile: null,
            visible: true,
            subida: false,
            almacenado: false,
            loading: false,

            fotoString: '',
        }
    },
    methods:
    {
        ...mapActions('dataUser', ['precargaFoto', 'subirFotoPerfil', 'guardarFotoCarnet', 'precargaFotoCarnet']),
        ...mapActions('preafiliacion', ['addFotoCarnet', 'guardarPreFotoCarnet']),

        enviarFoto() {
            if (this.tipo == 'fotoperfil') {
                this.selectedFile = null
                this.subirFotoPerfil({ nroafi: this.nroafi, fotoperfil: this.fototmp })
            } else if (this.tipo == 'fotocarnet') {
                if (this.isAuthenticated) {
                    this.guardarFotoCarnet()
                } else {
                    this.guardarPreFotoCarnet()
                    this.addFotoCarnet('')
                }
            }
            this.$emit("fotoCargada")
            this.selectedFile = null
            //vacio fototmp
            this.precargaFoto('')
            //this.subirFotoCarnet({ nroafi: this.nroafi, fotocarnet: this.fototmp })

        },
        descartar() {
            if (this.tipo == 'fotoperfil') {
                this.precargaFoto('')
            } else if (this.tipo == 'fotocarnet') {
                if (this.isAuthenticated) {
                    this.precargaFotoCarnet('')
                    this.precargaFoto('')
                } else {
                    this.addFotoCarnet('')
                }
            }
            this.selectedFile = null
            this.subida = false
        },
        handleFileImport() {
            this.isSelecting = true;

            // After obtaining the focus when closing the FilePicker, return the button state to normal
            window.addEventListener('focus', () => {
                this.isSelecting = false
            }, { once: true });

            // Trigger click on the FileInput
            try {
                this.$refs.uploader.click();
            } catch (error) {
                this.isSelecting = false
            }
        },

        onFileChanged(e) {
            if (e.target.files[0]) {
                this.selectedFile = e.target.files[0]
                const img = new Image()
                img.src = URL.createObjectURL(this.selectedFile)


                img.onload = () => {
                    const targetWidth = 278
                    const targetHeight = 278
                    let newWidth, newHeight;
                    if (img.width / img.height > targetWidth / targetHeight) {
                        newWidth = img.width * (targetHeight / img.height);
                        newHeight = targetHeight;
                    } else {
                        newWidth = targetWidth;
                        newHeight = img.height * (targetWidth / img.width);
                    }
                    let canvas = this.$refs.canvas
                    const ctx = canvas.getContext('2d');
                    canvas.width = targetWidth;
                    canvas.height = targetHeight;

                    ctx.clearRect(0, 0, canvas.width, canvas.height)

                    ctx.drawImage(img, -offsetX, -offsetY, newWidth, newHeight);


                    let dataURL = canvas.toDataURL('image/png');
                    const arr = dataURL.split(',');
                    this.$emit('fotoCargada', arr[1])
                }
            }
        },
    },
    computed: {
        ...mapGetters('auth', ['nroafi', 'isAuthenticated']),
        ...mapGetters('dataUser', ['fototmp', 'fototmpcarnet']),
    },
    props: {
        titulo: {
            type: String,
            required: true
        },
        icono: {
            type: String,
            required: true
        },
        tipo: {
            type: String,
            required: false
        },
        width: {
            type: Number,
            required: false
        }
    }
}
</script>